import { isLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { getIsProduction } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getEnvName";
import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";
import { getSettingQualtricsRetailerSurveyInterceptSampleRateBPS } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingQualtricsRetailerSurveyInterceptSampleRateBPS";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { loadQualtricsWithLinkToXMDirectory } from "@faire/web/common/in-product-survey/qualtrics";
import { loadQualtricsLoggedOutSurveys } from "@faire/web/common/in-product-survey/qualtrics/loadQualtricsLoggedOutSurveys";
import { loadQualtricsRetailerPortalSurveys } from "@faire/web/common/in-product-survey/qualtrics/loadQualtricsRetailerPortalSurveys";
import { logError } from "@faire/web/common/logging";
import { isBefore } from "date-fns/isBefore";
import { subDays } from "date-fns/subDays";

const MONTH_IN_DAYS = 30;

export const initializeRetailerPortalQualtrics = (user: IUser | undefined) => {
  try {
    const retailer = getRetailer();

    if (
      getIsProduction() &&
      user &&
      user.retailer_token &&
      retailer &&
      isAtleastMonthOld(retailer)
    ) {
      if (
        checkRandomSample(
          getSettingQualtricsRetailerSurveyInterceptSampleRateBPS()
        )
      ) {
        loadQualtricsWithLinkToXMDirectory(
          user.token,
          loadQualtricsRetailerPortalSurveys
        );
      }
    }
  } catch (e) {
    logError(e);
  }
};

const isAtleastMonthOld = (retailer: IRetailer): boolean => {
  if (!retailer.created_at) {
    return false;
  }

  const monthAgo = subDays(new Date(), MONTH_IN_DAYS);
  return isBefore(retailer.created_at, monthAgo);
};

export const initializeLoggedOutQualtrics = () => {
  try {
    if (getIsProduction() && !isLoggedInRetailer()) {
      loadQualtricsLoggedOutSurveys();
    }
  } catch (e) {
    logError(e);
  }
};

const checkRandomSample = (rate: number): boolean => {
  // Use the BPS value to determine a cutoff. E.g. 7000 / 100 will set 70 as a cutoff.
  // Then generate random number between 0 and 99 and check if that number is less than
  // the cutoff. E.g. if 70 is a cutoff, 0 through 69 will return true, 70-99 will return
  // false. This simulates a 70% random chance as 70/100 values return true.
  const samplePageViewsCutoff = rate / 100;

  return Math.floor(Math.random() * 100) < samplePageViewsCutoff;
};
